import { LEARNING_FEATURE_FLAGS, readEnvVariable } from '@repo/config';

export function isEnglishIqV2WebEnabled(): boolean {
  return readEnvVariable(LEARNING_FEATURE_FLAGS.englishIqV2Web) === 'true';
}
